<style lang="scss" scoped>
.linkAdd {
  /deep/ {
    .el-dialog__body {
      padding: 30px 20px;
    }
    .el-select .el-input {
      width: 100px;
    }
    .input-with-select .el-input-group__prepend {
      background-color: #fff;
    }
  }
}
.preview {
  height: 108px;
  border: 1px solid #bdc7db;
  padding: 20px 15px;
  position: relative;
  .title {
    color: #000;
    font-size: 18px;
    margin-bottom: 15px;
  }
  .info {
    width: 240px;
  }
  .desc {
    font-size: 16px;
    color: #9a9a9a;
  }
  .img {
    position: absolute;
    bottom: 20px;
    right: 15px;
    width: 80px;
    height: 80px;
  }
}
</style>

<template>
  <div>
    <div class="lib" @click="show">
      <slot></slot>
    </div>
    <el-dialog
      title="新建外链消息"
      :visible.sync="dialog"
      width="1000px"
      top="10vh"
      class="linkAdd"
      :append-to-body="true"
    >
      <el-row :gutter="40">
        <el-col :span="10">
          <div class="preview">
            <div class="info">
              <div class="title line2">{{form.title || '标题'}}</div>
              <div class="desc line3">{{form.desc || '摘要'}}</div>
            </div>
            <img :src="'http://api.socialon.z-p.tech'+form.img" alt class="img" v-if="form.img" />
          </div>
        </el-col>
        <el-col :span="13">
          <el-form ref="form" :model="form" label-width="60px" label-position="left">
            <el-form-item label="标题">
              <el-input v-model="form.title" type="text" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="摘要">
              <el-input v-model="form.desc" type="text" maxlength="200"></el-input>
            </el-form-item>
            <el-form-item label="链接">
              <el-input v-model="form.link" class="input-with-select" type="text" maxlength="500">
                <el-select v-model="form.type" slot="prepend" placeholder="请选择">
                  <el-option value="http://"></el-option>
                  <el-option value="https://"></el-option>
                </el-select>
              </el-input>
            </el-form-item>
            <el-form-item label="缩略图">
              <el-upload
                :show-file-list="false"
                action
                style="display:inline-block"
                :before-upload="beforeFn"
                :http-request="uploadImage"
                accept="image/jpeg, image/png, image/bmp, image/gif"
                class="mr10"
              >
                <el-button type="info" size="mini">上传文件</el-button>
              </el-upload>
              <span style="color:#9B9B9B">建议图片尺寸：200x200像素</span>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div class="alignc mt100">
        <el-button type="primary" @click="submit()">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import utils from '@/utils.js';

export default {
  components: {},
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  data() {
    return {
      form: {
        title: '',
        desc: '',
        type: 'http://',
        img: null,
        link: '',
      },
      radio: '',
      dialog: false,
    };
  },
  watch: {
    'form.title': {
      handler(val, oldval) {
        let iLen = utils.getStringLength(val);
        if (iLen > 50) {
          this.form.title = oldval;
        }
      },
    },
    'form.desc': {
      handler(val, oldval) {
        let iLen = utils.getStringLength(val);
        if (iLen > 200) {
          this.form.desc = oldval;
        }
      },
    },
    'form.link': {
      handler(val, oldval) {
        let iLen = utils.getStringLength(val);
        if (iLen > 500) {
          this.form.link = oldval;
        }
      },
    },
  },
  methods: {
    async uploadImage(file) {
      let fd = new FormData();
      fd.append('File', file.file);
      fd.append('Type', '2');
      let res = await this.$http.post(
        `/api/${this.id}/material/file/upload`,
        fd,
      );
      this.form.img = res.url;
    },
    beforeFn(file) {
      if (file.size > 5000 * 1024) {
        this.$message.error(`图片大小不能超过5mb`);
        return false;
      }
      return true;
    },
    show() {
      this.dialog = true;
    },
    async submit() {
      if (!this.form.title) {
        return this.$message.error('请输入标题');
      }
      if (!this.form.desc) {
        return this.$message.error('请输入摘要');
      }
      if (!this.form.link) {
        return this.$message.error('请输入链接');
      }
      if (!this.form.img) {
        return this.$message.error('请上传缩略图');
      }

      let res = await this.$http.post(`/api/${this.id}/material/outlink`, {
        title: this.form.title,
        digest: this.form.desc,
        thumburl: this.form.img,
        url: this.form.type + this.form.link,
      });
      this.$emit('confirm', res.material);
      this.dialog = false;
    },
  },
  mounted() {},
};
</script>
